import { render, staticRenderFns } from "./PasswordStrength.vue?vue&type=template&id=baff2484&scoped=true&"
import script from "./PasswordStrength.vue?vue&type=script&lang=js&"
export * from "./PasswordStrength.vue?vue&type=script&lang=js&"
import style0 from "./PasswordStrength.vue?vue&type=style&index=0&id=baff2484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baff2484",
  null
  
)

export default component.exports